export default __webpack_public_path__ + "static/media/circle-notch-solid.848fc069.svg";